//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DefaultFacts from "@/components/objects/public/shared-blocks/facts/design-variant/Default.vue";
import GreenFacts from "@/components/objects/public/shared-blocks/facts/design-variant/Green.vue";
import WhiteFacts from "@/components/objects/public/shared-blocks/facts/design-variant/White.vue";
import BlueFacts from "@/components/objects/public/shared-blocks/facts/design-variant/Blue.vue";
import ColorFacts from "@/components/objects/public/shared-blocks/facts/design-variant/Color.vue";
import MinimalismFacts from "@/components/objects/public/shared-blocks/facts/design-variant/Minimalism.vue";
import { v4 as uuidv4 } from 'uuid';
import { DesignExtra } from "@/utils/dto/objects.js";
import { getDefaultFactsSettingsForDesign, getDefaultThemeSettings } from "@/constants/ui.js";
import isEmpty from "lodash/isEmpty.js";

export default {
  name: "Facts",
  provide: {
    source: 'objFacts',
    module: 'facts'
  },
  props: {
    facts: {
      type: Object,
      default: () => null
    },
    objectLabel: {
      type: String,
      default: () => ''
    },
    user: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    const safeFacts = this.facts || {};
    const design = safeFacts.design || 'facts_default';
    const ui = safeFacts.ui_data || {};
    const defaultTheme = getDefaultThemeSettings(design, 'facts', this.$store)?.themes?.[0];
    return {
      currentDesign: design,
      currentTheme: ui.design_theme || defaultTheme?.theme || design,
      designExtra: isEmpty(safeFacts.design_extra) ? new DesignExtra(defaultTheme || getDefaultFactsSettingsForDesign(design)) : safeFacts.design_extra,
      currentTemplate: null
    }
  },
  computed: {
    getFactsItems() {
      var customItems = [];
      var customData = null;

      this.facts.items.map(item => {
        if (item.value.type === "number") {
          customData = this.formatNumber(item.value.data)
          item.value.data = customData
          customItems.push(item);
        } else {
          customItems.push(item);
        }
      });

      return customItems
    },
    renderComponent() {
      switch (this.currentDesign) {
      case "green":
        return GreenFacts
      case "white":
        return WhiteFacts
      case "blue":
        return BlueFacts
      case "color":
        return ColorFacts
      case "minimalism":
        return MinimalismFacts
      default:
        return DefaultFacts
      }
    },
    listInfo() {
      return {
        // label: this.facts.label,
        subLabel: this.sublabel || "",
        icon: this.icon,
        vistat_object: this.vistat_object,
        object_label: this.objectLabel,
        id: uuidv4(),
      }
    },
    getDefaultFactsSettingsForDesign() {
      return getDefaultFactsSettingsForDesign;
    },
  },
  methods: {
    onDesignChange(evt) {
      this.currentDesign = evt;
      const defaultTheme = getDefaultThemeSettings(evt, 'facts', this.$store)?.themes?.[0];
      this.designExtra = new DesignExtra(defaultTheme || getDefaultFactsSettingsForDesign(evt));
      this.currentTheme = defaultTheme?.theme || evt;
    },
    onThemeChange(evt) {
      this.currentTheme = evt;
      const designSettings = getDefaultThemeSettings(this.currentDesign, 'facts', this.$store);
      const themeObj = designSettings?.themes?.find(el => el.theme === evt);
      this.designExtra = new DesignExtra(themeObj || getDefaultFactsSettingsForDesign(this.currentDesign));
    },
    formatNumber: function (num) {
      const number = Number(num);

      if (Number.isNaN(number)) {
        return 0
      } else if (Math.abs(number) < 1e-4 || Math.abs(number) > 1e6) {
        const exponent = Math.floor(Math.log10(Math.abs(number)));
        const mantissa = number / Math.pow(10, exponent);

        return Number(`${mantissa.toFixed(4)}e${exponent >= 0 ? '+' : ''}${exponent}`);
        //return number.toExponential(2);
      } else {
        return Number(number.toFixed(4));
      }
    }
  }
}
